document.addEventListener("DOMContentLoaded", function() {

    // Add [open] on hovering wp-block-details is-style-numbered

    // Get all elements with the class 'wp-block-details'
    const detailsElements = document.querySelectorAll('.wp-block-details.is-style-numbered');

    // Loop through each element and add event listeners
    detailsElements.forEach((element) => {
        element.addEventListener('mouseenter', () => {
            element.setAttribute('open', '');
        });

        element.addEventListener('mouseleave', () => {
            element.removeAttribute('open');
        });
    });

});